import React from "react";

import Grid from "@mui/material/Grid";

import CriticidadeAltaEMI from "./CriticidadeAlta/CriticidadeAltaEMI";
import CriticidadeAltaGGPI from "./CriticidadeAlta/CriticidadeAltaGGPI";
import CriticidadeAltaAIO from "./CriticidadeAlta/CriticidadeAltaAIO";
import CriticidadeAltaIGC from "./CriticidadeAlta/CriticidadeAltaIGC";
import CriticidadeAltaPG from "./CriticidadeAlta/CriticidadeAltaPG";

import CriticidadeMediaEMI from "./CriticidadeMedia/CriticidadeMediaEMI";
import CriticidadeMediaGGPI from "./CriticidadeMedia/CriticidadeMediaGGPI";
import CriticidadeMediaAIO from "./CriticidadeMedia/CriticidadeMediaAIO";
import CriticidadeMediaIGC from "./CriticidadeMedia/CriticidadeMediaIGC";
import CriticidadeMediaPG from "./CriticidadeMedia/CriticidadeMediaPG";

import CriticidadeBaixaEMI from "./CriticidadeBaixa/CriticidadeBaixaEMI";
import CriticidadeBaixaGGPI from "./CriticidadeBaixa/CriticidadeBaixaGGPI";
import CriticidadeBaixaAIO from "./CriticidadeBaixa/CriticidadeBaixaAIO";
import CriticidadeBaixaIGC from "./CriticidadeBaixa/CriticidadeBaixaIGC";
import CriticidadeBaixaPG from "./CriticidadeBaixa/CriticidadeBaixaPG";

import PontosFortesEMI from "./PontosFortes/PontosFortesEMI";
import PontosFortesGGPI from "./PontosFortes/PontosFortesGGPI";
import PontosFortesAIO from "./PontosFortes/PontosFortesAIO";
import PontosFortesIGC from "./PontosFortes/PontosFortesIGC";
import PontosFortesPG from "./PontosFortes/PontosFortesPG";

import {
	criticidadeAlta,
	criticidadeMedia,
	criticidadeBaixa,
	pontosFortes,
} from "../../assets/data/criticidade.js";

import {
	formDataEMI,
	formDataGGPI,
	formDataAIO,
	formDataIGC,
	formDataPG,
} from "../../assets/data/form";

const Criticidade = ({ EMI, GGPI, AIO, IGC, PG }) => {
	const ALTA = {
		EMI: {
			ESTUDOS: 	EMI[formDataEMI.questoes[0].pergunta] === 1,
			REUNIOES: 	EMI[formDataEMI.questoes[1].pergunta] === 1,
		},
		GGPI: {
			PI: 	GGPI[formDataGGPI.questoes[0].pergunta] === 1,
			TT: 	[1, 2].includes(GGPI[formDataGGPI.questoes[1].pergunta]),
		},
		AIO: {
			ACOES: 		AIO[formDataAIO.questoes[0].pergunta] === 1,
			AUTOMACAO: 	AIO[formDataAIO.questoes[1].pergunta] === 1,
			MERCADOS:	AIO[formDataAIO.questoes[2].pergunta] === 1,
		},
		IGC: {
			INVESTIMENTO: 	IGC[formDataIGC.questoes[0].pergunta] === 1,
			CAPACITACAO: 	[1, 2].includes(IGC[formDataIGC.questoes[1].pergunta]),
			INCENTIVO: 		[1, 2].includes(IGC[formDataIGC.questoes[2].pergunta]),
			PARCERIA: 		[1, 2].includes(IGC[formDataIGC.questoes[3].pergunta]),
		},
		PG: 	PG[formDataPG.questoes[0].pergunta] === 1,
	};

	const MEDIA = {
		EMI: {
			ESTUDOS: [2, 3].includes(EMI[formDataEMI.questoes[0].pergunta]),
			REUNIOES: [2, 3].includes(EMI[formDataEMI.questoes[1].pergunta]),
		},
		GGPI: {
			PI: [2, 3].includes(GGPI[formDataGGPI.questoes[0].pergunta]),
			TT: GGPI[formDataGGPI.questoes[1].pergunta] === 3,
		},
		AIO: {
			ACOES: [2, 3].includes(AIO[formDataAIO.questoes[0].pergunta]),
			AUTOMACAO: AIO[formDataAIO.questoes[1].pergunta] === 2,
			MERCADOS: [2, 3].includes(AIO[formDataAIO.questoes[2].pergunta]),
		},
		IGC: {
			INVESTIMENTO: [2, 3].includes(
				IGC[formDataIGC.questoes[0].pergunta]
			),
			CAPACITACAO: IGC[formDataIGC.questoes[1].pergunta] === 3,
			INCENTIVO: IGC[formDataIGC.questoes[2].pergunta] === 3,
			PARCERIA: IGC[formDataIGC.questoes[3].pergunta] === 3,
		},
		PG: [2, 3].includes(PG[formDataPG.questoes[0].pergunta]),
	};

	const BAIXA = {
		EMI: {
			ESTUDOS: EMI[formDataEMI.questoes[0].pergunta] === 4,
			REUNIOES: EMI[formDataEMI.questoes[1].pergunta] === 4,
		},
		GGPI: {
			PI: GGPI[formDataGGPI.questoes[0].pergunta] === 4,
			TT: GGPI[formDataGGPI.questoes[1].pergunta] === 4,
		},
		AIO: {
			ACOES: AIO[formDataAIO.questoes[0].pergunta] === 4,
			AUTOMACAO: [3, 4].includes(AIO[formDataAIO.questoes[1].pergunta]),
			MERCADOS: AIO[formDataAIO.questoes[2].pergunta] === 4,
		},
		IGC: {
			INVESTIMENTO: IGC[formDataIGC.questoes[0].pergunta] === 4,
			CAPACITACAO: IGC[formDataIGC.questoes[1].pergunta] === 4,
			INCENTIVO: IGC[formDataIGC.questoes[2].pergunta] === 4,
			PARCERIA: IGC[formDataIGC.questoes[3].pergunta] === 4,
		},
		PG: PG[formDataPG.questoes[0].pergunta] === 4,
	};

	const FORTES = {
		EMI: {
			ESTUDOS: EMI[formDataEMI.questoes[0].pergunta] === 5,
			REUNIOES: EMI[formDataEMI.questoes[1].pergunta] === 5,
		},
		GGPI: {
			PI: GGPI[formDataGGPI.questoes[0].pergunta] === 5,
			TT: GGPI[formDataGGPI.questoes[1].pergunta] === 5,
		},
		AIO: {
			ACOES: AIO[formDataAIO.questoes[0].pergunta] === 5,
			AUTOMACAO: AIO[formDataAIO.questoes[1].pergunta] === 5,
			MERCADOS: AIO[formDataAIO.questoes[2].pergunta] === 5,
		},
		IGC: {
			INVESTIMENTO: IGC[formDataIGC.questoes[0].pergunta] === 5,
			CAPACITACAO: IGC[formDataIGC.questoes[1].pergunta] === 5,
			INCENTIVO: IGC[formDataIGC.questoes[2].pergunta] === 5,
			PARCERIA: IGC[formDataIGC.questoes[3].pergunta] === 5,
		},
		PG: PG[formDataPG.questoes[0].pergunta] === 5,
	};

	function ifAllFalseRenderNone(obj) {
		let isAllFalseEMI = Object.keys(obj.EMI).every((k) => {
			return obj.EMI[k] === false;
		});

		let isAllFalseGGPI = Object.keys(obj.GGPI).every((k) => {
			return obj.GGPI[k] === false;
		});

		let isAllFalseAIO = Object.keys(obj.AIO).every((k) => {
			return obj.AIO[k] === false;
		});

		let isAllFalseIGC = Object.keys(obj.IGC).every((k) => {
			return obj.IGC[k] === false;
		});

		let isAllFalsePG = obj.PG === false;

		return !(
			isAllFalseEMI &&
			isAllFalseGGPI &&
			isAllFalseAIO &&
			isAllFalseIGC &&
			isAllFalsePG
		);
	}

	return (
		<>
			<h2>Análise de Criticidade</h2>

			<p className="text-center">
				A Análise de Criticidade mostra os pontos fracos e fortes sobre
				sua organização relacionados à inovação.
			</p>

			<div className="mt-5 text-center">
				<Grid
					container
					columnSpacing={{ xs: 1, sm: 2, md: 3 }}
					className="d-flex justify-content-center"
				>
					<Grid item xs={12} md={3}>
						<p>
							<b>Criticidade Alta </b>
							<br />
							Pontos que mais precisam melhorar
						</p>
					</Grid>
					<Grid item xs={12} md={3}>
						<p>
							<b>Criticidade Média</b> <br />
							Pontos que precisam melhorar
						</p>
					</Grid>
					<Grid item xs={12} md={3}>
						<p>
							<b>Criticidade Baixa</b> <br />
							Pontos próximos ao desejável
						</p>
					</Grid>
					<Grid item xs={12} md={3}>
						<p>
							<b>Pontos Fortes</b> <br />
							Desejável
						</p>
					</Grid>
				</Grid>
				<hr />
			</div>

			<Grid
				container
				spacing={5}
				columnSpacing={{ xs: 1, sm: 2, md: 3 }}
				className="d-flex justify-content-center mt-1"
			>
				<Grid item zeroMinWidth xs={12} md={6}>
					<h1>Criticidade Alta</h1>
					{ifAllFalseRenderNone(ALTA) ? (
						<>
							<CriticidadeAltaEMI
								flag={ALTA.EMI}
								criticidade={criticidadeAlta.EMI}
							/>
							<CriticidadeAltaGGPI
								flag={ALTA.GGPI}
								criticidade={criticidadeAlta.GGPI}
							/>
							<CriticidadeAltaAIO
								flag={ALTA.AIO}
								criticidade={criticidadeAlta.AIO}
							/>
							<CriticidadeAltaIGC
								flag={ALTA.IGC}
								criticidade={criticidadeAlta.IGC}
							/>
							<CriticidadeAltaPG
								flag={ALTA.PG}
								criticidade={criticidadeAlta.PG}
							/>
						</>
					) : (
						<div className="d-flex">
							<h4 className="d-flex m-auto">Nenhum</h4>
						</div>
					)}
				</Grid>

				<Grid item zeroMinWidth xs={12} md={6}>
					<h1>Criticidade Média</h1>
					{ifAllFalseRenderNone(MEDIA) ? (
						<>
							<CriticidadeMediaEMI
								flag={MEDIA.EMI}
								criticidade={criticidadeMedia.EMI}
							/>
							<CriticidadeMediaGGPI
								flag={MEDIA.GGPI}
								criticidade={criticidadeMedia.GGPI}
							/>
							<CriticidadeMediaAIO
								flag={MEDIA.AIO}
								criticidade={criticidadeMedia.AIO}
							/>
							<CriticidadeMediaIGC
								flag={MEDIA.IGC}
								criticidade={criticidadeMedia.IGC}
							/>
							<CriticidadeMediaPG
								flag={MEDIA.PG}
								criticidade={criticidadeMedia.PG}
							/>
						</>
					) : (
						<div className="d-flex">
							<h4 className="d-flex m-auto">Nenhum</h4>
						</div>
					)}
				</Grid>

				<Grid item zeroMinWidth xs={12} md={6}>
					<h1>Criticidade Baixa</h1>
					{ifAllFalseRenderNone(BAIXA) ? (
						<>
							<CriticidadeBaixaEMI
								flag={BAIXA.EMI}
								criticidade={criticidadeBaixa.EMI}
							/>
							<CriticidadeBaixaGGPI
								flag={BAIXA.GGPI}
								criticidade={criticidadeBaixa.GGPI}
							/>
							<CriticidadeBaixaAIO
								flag={BAIXA.AIO}
								criticidade={criticidadeBaixa.AIO}
							/>
							<CriticidadeBaixaIGC
								flag={BAIXA.IGC}
								criticidade={criticidadeBaixa.IGC}
							/>
							<CriticidadeBaixaPG
								flag={BAIXA.PG}
								criticidade={criticidadeBaixa.PG}
							/>
						</>
					) : (
						<div className="d-flex">
							<h4 className="d-flex m-auto">Nenhum</h4>
						</div>
					)}
				</Grid>

				<Grid item zeroMinWidth xs={12} md={6}>
					<h1>Pontos Fortes</h1>
					{ifAllFalseRenderNone(FORTES) ? (
						<>
							<PontosFortesEMI
								flag={FORTES.EMI}
								criticidade={pontosFortes.EMI}
							/>
							<PontosFortesGGPI
								flag={FORTES.GGPI}
								criticidade={pontosFortes.GGPI}
							/>
							<PontosFortesAIO
								flag={FORTES.AIO}
								criticidade={pontosFortes.AIO}
							/>
							<PontosFortesIGC
								flag={FORTES.IGC}
								criticidade={pontosFortes.IGC}
							/>
							<PontosFortesPG
								flag={FORTES.PG}
								criticidade={pontosFortes.PG}
							/>
						</>
					) : (
						<div className="d-flex">
							<h4 className="d-flex m-auto">Nenhum</h4>
						</div>
					)}
				</Grid>
			</Grid>
		</>
	);
};

export default Criticidade;
